/**
 * Formats an account number with spaces for better readability
 * Example: "MRI200000002AA43" -> "MRI 200000002 AA 43"
 */
export const useAccountNumberFormatter = () => {
  const formatAccountNumber = (accountNumber: string | undefined | null): string => {
    if (!accountNumber) return '';
    if (accountNumber.length !== 16) return accountNumber;

    // Pattern: First 3 chars (prefix) + 9 digits + 2 letters + 2 digits
    // Example: MRI200000002AA43 -> MRI 200000002 AA 43
    const match = accountNumber.match(/^([A-Z]{3})(\d{9})([A-Z]{2})(\d{2})$/);

    if (match) {
      const [, prefix, digits, letters, lastDigits] = match;
      return `${prefix} ${digits} ${letters} ${lastDigits}`;
    }

    return accountNumber;
  };

  return {
    formatAccountNumber
  };
};
